export const imageWrapperStyles = {
  width: 84,
  height: 84,
  boxSizing: "border-box",
  overflow: "hidden",
  border: "1px solid transparent",
  borderRadius: "8px",
};

export const productCardContentStyles = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 1,
  padding: "0 !important",
};

export const descriptionStyles = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  flex: 1,
};

export const productListStyles = {
  borderBottom: `1px solid rgba(40, 40, 40, 0.12)`,
  paddingBottom: { xs: 2, lg: 2.5 },
  "&:not(:first-of-type)": {
    paddingTop: { xs: 2, lg: 2.5 },
  },
};
